<template>
  <el-dialog
    width="80%"
    :title="$t('re-conciliation.confirm')"
    :visible.sync="dialogVisible"
  >
    <div class="items">
      <el-row
        type="flex"
        justify="space-between"
        class="item pb-20"
      >
        <span class="item-property">
          {{ $t('re-conciliation.to-reconcile') }}
        </span>
        <span class="item-value">
          {{ (reConciliationData.toReconcile / 100).toLocaleString($localeString, { style: 'currency', currency: 'EUR' }) }}
        </span>
      </el-row>
    </div>
    <div slot="footer">
      <el-button
        :disabled="reConciliationData.toReconcile <= 0"
        type="primary"
        @click="reConciliation"
      >
        {{ $t('form.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ConfirmTeamReconciliation',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    teamId: {
      type: String,
      default: ''
    },
    dates: {
      type: Object,
      default: () => {
        return {
          startDate: '',
          endDate: ''
        };
      }
    }
  },
  data: () => ({
    reConciliationData: {}
  }),
  computed: {
    dialogVisible: {
      get: function () {
        return this.visible;
      },
      set: function (value) {
        this.$emit('update:visible', value);
      }
    }
  },
  watch: {
    visible: function (value) {
      if (value) {
        this.$adminApi.get(`api/v1/entities/teams/${this.teamId}/reconciliation`, {
          type: 'amount',
          strategy: 'simple',
          periodStart: this.dates.startDate || '',
          periodEnd: this.dates.endDate || ''
        }).then((response) => {
          if (!response.data.successful) {
            this.$message.warning('Oops, something went wrong');
          } else {
            this.reConciliationData = response.data.payload;
          }
        });
      }
    }
  },
  methods: {
    reConciliation () {
      this.$adminApi.post(`api/v1/entities/teams/${this.teamId}/reconciliation`, {
        type: 'amount',
        strategy: 'simple',
        periodStart: this.dates.startDate || '',
        periodEnd: this.dates.endDate || ''
      }).then((response) => {
        this.$store.dispatch('setReConciliationResponse', response.data);
        this.$router.push({ name: 'ReConciliationThankYou' });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.items {
  .item {
    border-bottom: 1px solid #e5e5e5;

    &-property {
      color: #000000;
      font-family: "Raleway Regular", serif;
      font-size: 16px;
    }

    &-value {
      color: #000000;
      font-family: "Raleway Bold", serif;
      font-size: 16px;
    }
  }
}
</style>
